import { Box } from "@chakra-ui/layout";
import { t } from "@lingui/macro";
import { OutgoingInvoiceTypeEnum } from "@src/__generated__/urql-graphql";
import { useInvoiceDetailStore } from "../../../store";
import { CardTitle, Item } from "../../common";
import { ItemsList } from "./ItemsList";
import { Total } from "./Total";

export const InvoiceItems = () => {
  const store = useInvoiceDetailStore();
  return (
    <div>
      <div className="mb-8">{store.invoice?.text_on_invoice}</div>
      <CardTitle>
        {store.invoice?.type === OutgoingInvoiceTypeEnum.CreditNote
          ? t`Credit note items`
          : t`Invoice items`}
      </CardTitle>
      <ItemsList />
      <div className="mb-10">
        <Item
          label={
            store.invoice?.type === OutgoingInvoiceTypeEnum.CreditNote
              ? t`Note on credit note`
              : t`Note on invoice`
          }
        >
          <Box whiteSpace="pre-wrap">{store.invoice?.note}</Box>
        </Item>
      </div>
      <Total />
    </div>
  );
};
